/**
 * Wachtwoord hashing met SHA-256 + salt
 * Veiliger dan plaintext — wachtwoorden worden nooit in leesbare vorm opgeslagen.
 */

const SALT = 'slaaploods-verlof-2026'; // Vaste salt per installatie

/**
 * Valideer wachtwoord sterkte
 * @returns {{ valid: boolean, errors: string[] }}
 */
export function valideerWachtwoord(wachtwoord) {
  const errors = [];
  if (!wachtwoord) return { valid: false, errors: ['Wachtwoord is verplicht'] };
  if (wachtwoord.length < 8) errors.push('Minimaal 8 tekens');
  if (!/[A-Z]/.test(wachtwoord)) errors.push('Minimaal 1 hoofdletter');
  if (!/[a-z]/.test(wachtwoord)) errors.push('Minimaal 1 kleine letter');
  if (!/[0-9]/.test(wachtwoord)) errors.push('Minimaal 1 cijfer');
  return { valid: errors.length === 0, errors };
}

export async function hashWachtwoord(wachtwoord) {
  if (!wachtwoord) return '';
  const data = new TextEncoder().encode(SALT + wachtwoord);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return 'sha256:' + hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function verifyWachtwoord(wachtwoord, storedHash) {
  if (!wachtwoord || !storedHash) return false;
  
  // Backward compatibility: als stored hash GEEN prefix heeft, is het plaintext
  if (!storedHash.startsWith('sha256:')) {
    // Plaintext vergelijking (oude accounts)
    return wachtwoord === storedHash;
  }
  
  // Gehashte vergelijking
  const hash = await hashWachtwoord(wachtwoord);
  return hash === storedHash;
}

export function isGehasht(storedHash) {
  return storedHash && storedHash.startsWith('sha256:');
}
